import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private loaderSubject: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  public loaderState$: Observable<boolean> = this.loaderSubject.asObservable();

  constructor() {}

  public show(): void {
    this.loaderSubject.next(true);
  }

  public hide(): void {
    this.loaderSubject.next(false);
  }
}
